module.exports = __webpack_public_path__ + "img/HOS-InProgress.f04dcbf4.png";